
const Feedback = ( ) => {

  
    return (
        <div id="feedback">
           <h1>This is the Descriptive Feedback section</h1>
    </div>
  )
}
 
export default Feedback;